import React from 'react';
import PropertyCard from './PropertyCard';
import Icon from '../../../components/AppIcon';


const PropertyGrid = ({ properties, type, loading }) => {
  if (loading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {[...Array(6)]?.map((_, index) => (
          <div key={index} className="bg-card rounded-xl shadow-subtle overflow-hidden animate-pulse">
            <div className="h-48 sm:h-56 bg-muted"></div>
            <div className="p-6">
              <div className="h-6 bg-muted rounded mb-3"></div>
              <div className="h-4 bg-muted rounded mb-4"></div>
              <div className="flex space-x-3 mb-6">
                <div className="h-4 bg-muted rounded flex-1"></div>
                <div className="h-4 bg-muted rounded flex-1"></div>
              </div>
              <div className="flex space-x-3">
                <div className="h-8 bg-muted rounded flex-1"></div>
                <div className="h-8 bg-muted rounded flex-1"></div>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (properties?.length === 0) {
    return (
      <div className="text-center py-12">
        <div className="w-16 h-16 bg-muted rounded-full flex items-center justify-center mx-auto mb-4">
          <Icon name={type === 'apartment' ? 'Building' : 'Bed'} size={24} className="text-muted-foreground" />
        </div>
        <h3 className="font-heading text-lg font-semibold text-foreground mb-2">
          No {type === 'apartment' ? 'Apartments' : 'Rooms'} Available
        </h3>
        <p className="text-muted-foreground">
          Please check back later or contact us for availability.
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {properties?.map((property) => (
        <PropertyCard
          key={property?.id}
          property={property}
          type={type}
        />
      ))}
    </div>
  );
};

export default PropertyGrid;